import {collapseNewlines, collapseWhitespace, stripTags} from './converterUtils';

export function convertToMarkdown(html: string): string {
  let text = collapseWhitespace(html);

  // Bold: <strong>/<b> -> **
  text = text.replace(/<\/?(?:strong|b)>/gi, '**');

  // Italic: <em>/<i> -> _
  text = text.replace(/<\/?(?:em|i)>/gi, '_');

  // Underline: <u> -> __
  text = text.replace(/<\/?u>/gi, '__');

  // Line break: <br> -> two trailing spaces + newline
  text = text.replace(/<br\s*\/?>/gi, '  \n');

  // Paragraph: <p> removed, </p> -> blank line
  text = text.replace(/<p>/gi, '');
  text = text.replace(/<\/p>/gi, '\n\n');

  // Ordered lists: <ol>...</ol> with numbered items
  text = text.replace(/<ol>(.*?)<\/ol>/gis, (_match, inner: string) => {
    let counter = 0;
    return (
      '\n' +
      inner.replace(/<li>(.*?)<\/li>/gis, (_m: string, content: string) => {
        const trimmed = content.trim();
        if (trimmed === '') {
          return '';
        }
        counter++;
        return `${counter}. ${trimmed}\n`;
      }) +
      '\n'
    );
  });

  // Unordered lists: <ul>...</ul> with dashes
  text = text.replace(
    /<ul>(.*?)<\/ul>/gis,
    (_match, inner: string) =>
      '\n' +
      inner.replace(/<li>(.*?)<\/li>/gis, (_m: string, content: string) => {
        const trimmed = content.trim();
        if (trimmed === '') {
          return '';
        }
        return `- ${trimmed}\n`;
      }) +
      '\n'
  );

  // Strip all remaining HTML tags
  text = stripTags(text);

  // No html_entity_decode — entities pass through as-is (matches BE)

  // Collapse 3+ consecutive newlines to 2
  text = collapseNewlines(text);

  return text.trim();
}
